import React from 'react';
import { Book } from 'lucide-react';
export function Navbar() {
  return <nav className="sticky top-0 z-50 bg-brand-dark/95 backdrop-blur-md border-b border-white/10 px-4 py-3" data-id="element-88">
      <div className="max-w-6xl mx-auto flex items-center justify-between" data-id="element-89">
        <div className="flex items-center gap-2 text-white font-heading font-bold text-lg md:text-xl uppercase" data-id="element-90">
          <Book className="w-5 h-5 text-brand-accent" data-id="element-91" />
          <span data-id="element-92">Salud y Adolescencia 360</span>
        </div>

        <div className="hidden md:flex items-center gap-6 text-sm font-body font-medium text-gray-300" data-id="element-93">
          <a href="#bonos" className="hover:text-white transition-colors" data-id="element-94">
            Bonos
          </a>
          <a href="#testimonios" className="hover:text-white transition-colors" data-id="element-95">
            Testimonios
          </a>
          <a href="#compra" className="bg-brand-accent hover:bg-brand-accentHover text-white px-6 py-2 rounded-full font-heading font-bold uppercase transition-colors shadow-lg shadow-brand-accent/20" data-id="element-96">
            COMPRAR
          </a>
        </div>
      </div>
    </nav>;
}